import store from '@/store'

export default [
  {
    path: '/vehicle-profiles',
    name: 'vehicle-profile',
    meta: { requiresAuth: true },
    component: () => import('@/pages/vehicle-profile/index.vue')
  },
  {
    path: '/vehicle-profiles/create',
    name: 'vehicle-profile-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/vehicle-profile/create.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('vehicleProfile/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/vehicle-profiles/:id',
    name: 'vehicle-profile-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/vehicle-profile/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('vehicleProfile/dataBeforeCreate')
      await store.dispatch('vehicleProfile/find', to.params.id)
      next()
    }
  }
]
